// utils/fontPreload.ts
import DINBoldWoff2 from '@/assets/font/DINAlternate-Bold.woff2'
import DINBoldWoff from '@/assets/font/DINAlternate-Bold.woff'
import SourceHanSansCNWoff2 from '@/assets/font/SourceHanSansCN-Bold-subset.woff2'

export function preloadFonts() {
  const fonts = [
    { href: DINBoldWoff2, type: 'font/woff2' },
    { href: DINBoldWoff, type: 'font/woff' },
    { href: SourceHanSansCNWoff2, type: 'font/woff2' },
  ]

  fonts.forEach((f) => {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'font'
    link.href = f.href
    link.type = f.type
    link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  })
}
